// extracted by mini-css-extract-plugin
export default {"genericCard":"zo-z","inline":"Ao-z","mastercard":"Bo-z","discover":"Co-z","visa":"Do-z","amex":"Eo-z","active":"Fo-z"};